// utils/helpers/helper.constant.js
const BASE_PROD_NAME = process.env.PROD_NAME_ENV || "production";

const getProdSubject = (nameEnv) => {
  console.log('getProdSubject: ', nameEnv)
  if (nameEnv?.indexOf('arbaz') >= 0) {
    return SUBJECTS_BY_SCHOOL_ARBAZ;
  } else if (nameEnv?.indexOf('co-herens') >= 0) {
    return SUBJECTS_BY_SCHOOL_CO_HERENS;
  } else {
    return SUBJECTS_BY_SCHOOL;
  }
};

const getProdSchoolName = (nameEnv) => {
  console.log('getProdSubject: ', nameEnv)
  if (nameEnv?.indexOf('arbaz') >= 0) {
    return 'École de Arbaz';
  } else if (nameEnv?.indexOf('co-herens') >= 0) {
    return 'École de CO Euseigne';
  } else {
    return `École de Gravelone, Sion`;
  }
};

export const COURSE_TIME_RANGE = 5;

export const SCHOOL_INFORMATION = {
  _id: 1,
  name: getProdSchoolName(BASE_PROD_NAME),
};

export const SUBJECTS_BY_SCHOOL = [
  {
    label: 'Math',
    color: '#000000',
    school: 1,
  },
  {
    label: 'Sciences',
    color: '#000000',
    school: 1,
  },
  {
    label: 'Français',
    color: '#2070FF',
    school: 1,
  },
  {
    label: 'Allemand',
    color: '#B620E0',
    school: 1,
  },
  {
    label: 'Anglais',
    color: '#FF004E',
    school: 1,
  },
  {
    label: 'Sport',
    color: '#B200CA',
    school: 1,
  },
  {
    label: 'Informatique',
    color: '#612712',
    school: 1,
  },
  {
    label: 'Histoire',
    color: '#0200FF',
    school: 1,
  },
  {
    label: 'Religion',
    color: '#C5CA00',
    school: 1,
  },
  {
    label: 'Géographie',
    color: '#47D326',
    school: 1,
  },
  {
    label: 'Art visuel',
    color: '#CA0000',
    school: 1,
  },
  {
    label: 'Musique',
    color: '#CA6400',
    school: 1,
  },
];
export const SUBJECTS_BY_SCHOOL_ARBAZ = [
  {
    label: 'Éducation physique',
    abbreviation: 'Éducation physique',
    color: '#B200CA'
  },
  {
    label: 'Activité en classe',
    abbreviation: 'Activité en classe',
    color: '#FFAA00'
  },
  { label: 'Dessin', abbreviation: 'Dessin', color: '#CA0000' },
  {
    label: 'Mathématiques',
    abbreviation: 'Mathématiques',
    color: '#000000'
  },
  { label: 'Français', abbreviation: 'Français', color: '#2070FF' },
  { label: 'Musique', abbreviation: 'Musique', color: '#CA6400' },
  {
    label: 'Activité complémentaire',
    abbreviation: 'Activité complémentaire',
    color: '#FF00AA'
  },
  {
    label: 'Environnement',
    abbreviation: 'Environnement',
    color: '#AA00FF'
  },
  { label: 'AC&M', abbreviation: 'AC&M', color: '#00FFAA' },
  {
    label: 'Géographie',
    abbreviation: 'Géographie',
    color: '#47D326'
  },
  {
    label: 'Ens. religieux',
    abbreviation: 'Ens. religieux',
    color: '#C5CA00'
  },
  {
    label: 'Mathématiques / Ens. religieux',
    abbreviation: 'Mathématiques / Ens. religieux',
    color: '#000000'
  },
  { label: 'Histoire', abbreviation: 'Histoire', color: '#0200FF' },
  {
    label: 'Dessin / Mathématiques',
    abbreviation: 'Dessin / Mathématiques',
    color: '#CA0000'
  },
  { label: 'Allemand', abbreviation: 'Allemand', color: '#B620E0' },
  {
    label: 'Etudes dirigées',
    abbreviation: 'Etudes dirigées',
    color: '#FFAA00'
  },
  { label: 'Sciences', abbreviation: 'Sciences', color: '#000000' }
];

export const SUBJECTS_BY_SCHOOL_CO_HERENS = [
  { label: 'Français', abbreviation: 'FRA', color: '#2070FF' },
  { label: 'Allemand', abbreviation: 'ALL', color: '#B620E0' },
  {
    label: 'Éducation physique',
    abbreviation: 'EPH',
    color: '#B200CA'
  },
  { label: 'Musique', abbreviation: 'ARTM', color: '#CA6400' },
  { label: 'Dessin', abbreviation: 'AV', color: '#CA0000' },
  { label: 'Mathématiques', abbreviation: 'MATH', color: '#000000' },
  { label: 'Anglais', abbreviation: 'ANG', color: '#FF004E' },
  { label: 'Travaux manuels', abbreviation: 'TM', color: '#FF00AA' },
  { label: 'Economie familial', abbreviation: 'EF', color: '#AA00FF' },
  {
    label: 'Ethique et culture religieuse',
    abbreviation: 'ECR',
    color: '#AA00FF'
  },
  { label: 'Sciences', abbreviation: 'SCI', color: '#000000' },
  { label: 'Informatique', abbreviation: 'INFO', color: '#612712' },
  {
    label: 'Sciences humaines et sociales',
    abbreviation: 'SHS',
    color: '#C5CA00'
  },
  { label: 'Projet personnel', abbreviation: 'PP', color: '#47D326' },
];



export const SUBJECTS_OPTIONS = getProdSubject(BASE_PROD_NAME).map(elem => {
  return {
    key: elem.label,
    label: elem.label,
    value: elem.label,
    color: elem.color,
  };
}).sort((a, b) => a?.label?.localeCompare(b?.label));

// Motif: Medical
export const DISPENSARY_PROGRAM = [
  {
    key: 'Médecin généraliste',
    value: 'Médecin généraliste',
    label: 'Médecin généraliste',
  },
  {
    key: 'Dentiste',
    value: 'Dentiste',
    label: 'Dentiste',
  },
  {
    key: 'Orthophoniste',
    value: 'Orthophoniste',
    label: 'Orthophoniste',
  },
  {
    key: 'Psychiatre',
    value: 'Psychiatre',
    label: 'Psychiatre',
  },
  {
    key: 'Neurologue',
    value: 'Neurologue',
    label: 'Neurologue',
  },
  {
    key: 'Endocrinologue',
    value: 'Endocrinologue',
    label: 'Endocrinologue',
  },
  {
    key: 'Chirurgien',
    value: 'Chirurgien',
    label: 'Chirurgien',
  },
  {
    key: 'Urologue-andrologue',
    value: 'Urologue-andrologue',
    label: 'Urologue-andrologue',
  },
  {
    key: 'Traumatologue-orthopédiste',
    value: 'Traumatologue-orthopédiste',
    label: 'Traumatologue-orthopédiste',
  },
];
// No-Medical
export const ACTIVITY_REASON = [
  {
    key: 'Activité sportive',
    value: 'Activité sportive',
    label: 'Activité sportive',
  },
  {
    key: 'Activité artistique',
    value: 'Activité artistique',
    label: 'Activité artistique',
  },
  {
    key: 'Ensevelissement',
    value: 'Ensevelissement',
    label: 'Ensevelissement',
  },
];

// only for parent and for communication creation functionality
export const PARENT_COMM_REASON = [
  {
    key: 'Demande d’information',
    value: 'Demande d’information',
    label: 'Demande d’information',
  },
  {
    key: 'Rendez-vous',
    value: 'Rendez-vous',
    label: 'Rendez-vous',
  },
  {
    key: 'Divers',
    value: 'Divers',
    label: 'Divers',
  },
];

// Récurance
export const RECURRING = [
  {
    key: 'every_day',
    value: 'every_day',
    label: 'Tous les jours',
  },
  {
    key: 'every_week',
    value: 'every_week',
    label: 'Toutes les semaines',
  },
  {
    key: 'every_month',
    value: 'every_month',
    label: 'Chaque mois',
  },
];
// 1 - Monday
// 7 - Sunday
export const DAY_OF_WEEK = [
  {
    key: 'monday', // Lun, Lu
    label: 'Lundi',
    value: 'lundi',
  },
  {
    key: 'tuesday', // Mar, Ma
    label: 'Mardi',
    value: 'mardi',
  },
  {
    key: 'wednesday', // Mer, Me
    label: 'Mercredi',
    value: 'mercredi',
  },
  {
    key: 'thursday', // Jeu, Je
    label: 'Jeudi',
    value: 'jeudi',
  },
  {
    key: 'friday', // Ven, Ve
    label: 'Vendredi',
    value: 'vendredi',
  },
  {
    key: 'saturday', // Sam, Sa
    label: 'Samedi',
    value: 'samedi',
  },
  {
    key: 'sunday', // Dim, Di
    label: 'Dimanche',
    value: 'dimanche',
  },
];
export const DAY_OF_WEEK_OPTIONS = DAY_OF_WEEK;

export const STATUSES_LIST = [
  {
    key: 'pending',
    label: 'En cours de traitement',
    value: 'pending',
  },
  {
    key: 'justification-missing',
    label: 'Justificatif à fournir',
    value: 'justification-missing',
  },
  {
    key: 'sick',
    label: 'Malade',
    value: 'sick',
  },
  {
    key: 'sickness-finish',
    label: 'Maladie terminée',
    value: 'sickness-finish',
  },
  {
    key: 'accepted',
    label: 'Accepté',
    value: 'accepted',
  },
  {
    key: 'refused',
    label: 'Refusé',
    value: 'refused',
  },
];

export const ABS_TYPES_LIST = [
  {
    key: 'medical',
    value: 'medical',
    label: 'Médicale',
    title: 'Médicale',
  },
  {
    key: 'no-medical',
    value: 'no-medical',
    label: 'Non-médicale',
    title: 'Non-médicale',
  },
  {
    key: 'sickness',
    value: 'sickness',
    label: 'Maladie',
    title: 'Maladie',
  },
];

export const TYPES_LIST = [
  {
    key: "documents",
    value: "documents",
    label: "Documents",
    title: "Documents",
  },
  {
    key: "forms",
    value: "forms",
    label: "Formulaire",
    title: "Formulaire",
  },
  {
    key: "appointments",
    value: "appointments",
    label: "Rendez-vous",
    title: "Rendez-vous",
  },
  {
    key: "discussion",
    value: "discussion",
    label: "Discussion",
    title: "Discussion",
  },
  {
    key: "no-type",
    value: "no-type",
    label: "Pas de type",
    title: "Pas de type",
  },
];

export const LEVELS_OPTIONS = [
  {
    key: 0,
    label: 'Pas de niveau',
    value: 0,
  },
  {
    key: 1,
    label: 'Niveau I',
    value: 1,
  },
  {
    key: 2,
    label: 'Niveau II',
    value: 2,
  },
  {
    key: 3,
    label: 'Niveau III',
    value: 3,
  },
  // {
  //   key: 4,
  //   label: 'Niveau IV',
  //   value: 4,
  // },
  // {
  //   key: 5,
  //   label: 'Niveau V',
  //   value: 5,
  // },
];

export const YEARS_OPTIONS = [
  {
    key: '2021 - 2022',
    label: '2021 - 2022',
    value: '2021 - 2022',
  },
  {
    key: '2022 - 2023',
    label: '2022 - 2023',
    value: '2022 - 2023',
  },
  {
    key: '2023 - 2024',
    label: '2023 - 2024',
    value: '2023 - 2024',
  },
];

export const ABSENCES_DURATIONS = {
  all: {
    month: '140 heures 45 minutes',
    semester: '2400 heures 30 minutes',
    year: '6003 heures',
  },
  medical: {
    month: '31 heures 15 minutes',
    semester: '411 heures',
    year: '1056 heures 15 minutes',
  },
  nonMedical: {
    month: '23 heures 30 minutes',
    semester: '200 heures',
    year: '560 heures 30 minutes',
  },
  sickness: {
    month: '86 heures',
    semester: '1789 heures 30 minutes',
    year: '4386 heures 15 mintutes',
  },
};

export const ABSENCES_DURATIONS_STUDENT = {
  all: {
    month: '14 heures',
    semester: '40 heures 30 minutes',
    year: '64 heures 45 minutes',
  },
  medical: {
    month: '5 heures 30 minutes',
    semester: '3 heures 5 minutes',
    year: '28 heures',
  },
  nonMedical: {
    month: '1 heures 30 minutes',
    semester: '16 heures 55 minutes',
    year: '8 heures',
  },
  sickness: {
    month: '7 heures',
    semester: '20 heures 30 minutes',
    year: '28 heures 45 minutes',
  },
};

export const USER_TYPES = {
  'student': 'Etudiant',
  'teacher': 'Enseignant',
  'parent': 'Parent',
  'admin': 'Admin',
};

export const AUDIENCE_TABLE_STATUS = {
  'read': 'Lu',
  'notRead': 'Non Lu',
  'answered': 'Répondu',
};
